import React, { useContext } from 'react';
import InnerUnreadCoachCommentsBadge from '../../Challenge/ChallengeCard/UnreadCoachCommentsBadge/InnerUnreadCoachCommentsBadge';
import ChallengeContext from '../../Challenge/ChallengeView/ChallengeContext';
import useIsPortfolioReadonly from '../../useIsPortfolioReadonly';
import { type TaskSummary } from '@/lib/types';

type UnreadCoachCommentsBadgeProps = {
  task: TaskSummary;
  children: React.ReactNode;
};

const UnreadCoachCommentsBadge = ({
  task,
  children,
}: UnreadCoachCommentsBadgeProps) => {
  const portfolioIsReadonly = useIsPortfolioReadonly();
  const [, setChallenge] = useContext(ChallengeContext);

  const unreadCoachCommentsCount = task._count.coachComments;

  const markCoachCommentsAsRead = () => {
    if (unreadCoachCommentsCount === 0 || portfolioIsReadonly) {
      return;
    }

    setChallenge(challenge => {
      challenge.tasks[task.id]._count.coachComments = 0;
    });
  };

  return (
    <InnerUnreadCoachCommentsBadge
      unreadCoachCommentsCount={unreadCoachCommentsCount}
      onClick={markCoachCommentsAsRead}
    >
      {children}
    </InnerUnreadCoachCommentsBadge>
  );
};

export default UnreadCoachCommentsBadge;
